const messages = {
  'aboutUs.groupImgAltText': 'grupo de Manos Sin Fonteras',
  'aboutUs.text': 'Este blog es una iniciativa de ',
  'aboutUs.textSecond': ', que tiene como objetivo compartir conocimientos únicos y experiencias inspiradoras de todas partes del mundo. ',
  'aboutUs.textThird': 'Te invitamos a conocer diferentes perspectivas sobre temas como el bienestar, las emociones, una mente sana y cualquier otro tema que te interese. ',
  'aboutUs.textFourth': 'Además, te compartimos testimonios que revelan los beneficios de la Estimulación Neural y la meditación ya sea en el trabajo, los estudios, la familia o en la vida personal. ',
  'aboutUs.textFifth': 'Así que relájate y disfruta de cada uno de nuestros artículos ',
  'aboutUs.copyright': 'Los artículos en este blog son propiedad de Manos Sin Fronteras, salvo que se indique lo contrario.',
  'aboutUs.LJQuote': '"Lo que no se comparte se pierde" ',
  'aboutUs.manos': 'Manos Sin Fronteras',

  'article.author': 'Escrito por: ',
  'article.contribute': 'Únete a nuestra red de escritores y comparte tu conocimiento en nuestra plataforma',

  'category.emptyQuery': 'No hemos encontrado ningún artículo',
  'category.mentalHealth': 'Mente Sana',
  'category.others': 'Otros',
  'category.physicalWellbeing': 'Bienestar Físico',
  'category.selfawareness': 'Autoconocimiento',
  'category.noMoreViolence': '#niUnaMenos',
  'category.reflections': 'Reflexiones',
  'categories.title': 'Categorías',

  'contact.name': 'Nombre',
  'contact.email': 'Correo',
  'contact.message': 'Mensaje',
  'contact.submit': 'Enviar',
  'contact.worldMap': 'MSF en el Mundo',

  'contribute.altText': 'desenho de mão escrevendo',
  'contribute.text': '¿Quieres formar parte de nuestro equipo de colaboradores y colaboradoras del blog? Perfecto, envianos un artículo o testimonio de un tema que te apasione. ',
  'contribute.secondText': 'Tu conocimiento y tus experiencias son la vida de este blog.',
  'contribute.thirdText': 'No te preocupes si la redacción no es tu fuerte, estamos preparados para guiarte en el proceso. ',
  'contribute.join': '¡Únete a nuestra red de escritores y sorpréndenos con tu mensaje en nuestra próxima "newsletter"!',
  'contribute.translation': 'Nuestro equipo se encargará de las traducciones',

  'footer.manos.label': 'MSF_int',
  'footer.manos.altText': 'Mundo Monocromo',
  'footer.yoMedito.label': 'Yo Medito',
  'footer.yoMedito.altText': 'Globo monocromo',
  'footer.laJardinera.label': 'La Jardinera',
  'footer.laJardinera.altText': 'Flor monocromática',
  'footer.copyright': '© 2018 Manos Sin Fronteras',

  'legal.address.label': 'Dirección Registrada',
  'legal.address.line1': 'Manos Sin Fronteras Internacionales',
  'legal.address.line2': 'C/ Ribargorza no. 18',
  'legal.address.line3': 'Entresuelo B de Zaragoza',
  'legal.address.line4': '50003 (Zaragoza)',
  'legal.contact.email': 'Correo Electrónico: ',
  'legal.contact.phone': 'Teléfono: +34 658 77 46 78',
  'legal.contact.website': 'Sitio Web: ',
  'legal.representative.label': 'Representante Legal',
  'legal.representative.name': 'Lucía Peña',
  'legal.representative.with': 'Registro: Diputación General de Aragón',
  'legal.representative.number': 'Número de Registro: 01-Z-2070-2007',
  'legal.representative.code': 'Código de Identificación Definitivo: G99197394',
  'legal.disclaimer.label': 'Declaración Legal',
  'legal.disclaimer.text': 'El contenido de este sitio web está basado en normas de España, salvo indicación expresa en contrario. Las opiniones y criterios publicados en los artículos representan aquellos de los autores y no el de El Blog de Manos Sin Fronteras Internacionales y sus creadores. Si existe alguna sugerencia o reclamo respecto lo aquí publicado, agradecemos dirigirse a la sección de contacto para atender su comunicación. Todos los artículos aquí publicados tienen el consentimiento expreso de su autor.',

  'locale.en': 'English',
  'locale.es': 'Español',
  'locale.it': 'Italiano',
  'locale.pt': 'Português',

  'meta.description.aboutUs': 'Somos Manos Sin Fronteras y hemos creado este blog para compartir experiencias inspiradoras y conocimientos únicos. Además, te compartimos testimonios que revelan los beneficios de la Estimulación Neural.',
  'meta.description.contactUs': '¿Quieres compartir tus experiencias y conocimientos? ¿Tienes comentarios o preguntas sobre el sitio o los artículos que publicamos? Escribenos un mensaje y te contestaremos enseguida.',
  'meta.description.contribute': 'Te invitamos a compartir con nuestros lectores ese tema que te apasiona o esas experiencias que han sido fundamentales en tu crecimiento personal. ¡Tu conocimiento y tus experiencias son la vida de este blog!',
  'meta.description.home': 'Bienvenidos al Blog de Manos Sin Fronteras! Te invitamos a disfrutar nuestros artículos sobre conocimientos y experiencias relacionadas con el bienestar físico, una mente sana y el crecimiento personal.',
  'meta.description.mentalHealth': 'Encuentra artículos sobre cómo afrontar situaciones y tensiones de la vida de una manera saludable. Lee sobre las situaciones difíciles con las que se han encontrado nuestros escritores y descubre cómo han logrado recobrar el bienestar mental y emocional.',
  'meta.description.others': 'En esta pagina encontraras articulos interesantes de temas variados que el equipo que maneja el blog MSF considera que son importantes para compartir pero no son sobre el bienestar mental, física o un testimonio relacionado con la Enseñanza.',
  'meta.description.physicalWellbeing': 'Aquí encontrarás artículos sobre cómo crear hábitos para mejorar tu bienestar físico y el vínculo entre las emociones, una mente sana y la salud de tu cuerpo.',
  'meta.description.selfawareness': 'Conoce cómo la meditación, la estimulación neural o los viajes especiales han acelerado una autoconciencia en diferentes personas y sus experiencias en este trayecto a conocerse mejor.',
  'meta.description.noMoreViolence': 'Respiro y soy dueña de mi vida, 5 minutos por tu voz',

  'menu.aboutUs': 'Sobre Nosotros',
  'menu.contactUs': 'Contáctanos',
  'menu.contribute': 'Contribuye',
  'menu.home': 'Inicio',
  'menu.legal': 'Nota Legal',

  'sidePanel.estimulacionNeural.altText': 'Estimulación Neural',
  'sidePanel.estimulacionNeural.text': 'Una técnica para tu bienestar físico, mental y emocional.',
  'sidePanel.estimulacionNeural.title': 'Estimulación Neural',
  'sidePanel.laJardinera.altText': 'Flor Rosada',
  'sidePanel.laJardinera.text': 'Precursora de la Estimulación Neural, ha dedicado su vida a ayudar al planeta.',
  'sidePanel.laJardinera.title': 'La Jardinera',
  'sidePanel.yoMedito.altText': 'Globo - Yo Medito',
  'sidePanel.yoMedito.text': 'Cuando tú estás en paz, el mundo está en paz.',
  'sidePanel.yoMedito.title': 'Yo Medito',

  'template.comments': 'Escribe tus comentarios',
};

export default messages;
